import script from "./UserNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNotification.vue?vue&type=script&setup=true&lang=js"

import "./UserNotification.vue?vue&type=style&index=0&id=fde1f542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde1f542"]])

export default __exports__